export default __webpack_public_path__ + "static/media/046-motherhood.54449636.png";